export default [{
  path: '/documentos',
  component: {
    name: 'documentosBase',
    template: '<router-view />',
    meta: {
      resource: 'documento',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'documentos',
    component: () => import('@/app-modulo/documento/documento/DocumentoView.vue'),
    meta: {
      resource: 'documento',
      action: 'read',
      navActiveLink: 'documentos',
      pageTitle: 'Documentos',
      breadcrumb: [
        {
          text: 'Documentos',
          to: { name: 'documentos' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-documento',
    component: () => import('@/app-modulo/documento/documento/shared/components/cadastro/Documento.vue'),
    meta: {
      resource: 'documento',
      action: 'create',
      navActiveLink: 'documentos',
      pageTitle: 'Documentos',
      breadcrumb: [
        {
          text: 'Documentos',
          to: { name: 'documentos' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-documento' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-documento',
    component: () => import('@/app-modulo/documento/documento/shared/components/cadastro/Documento.vue'),
    meta: {
      resource: 'documento',
      action: 'update',
      navActiveLink: 'documentos',
      pageTitle: 'Documentos',
      breadcrumb: [
        {
          text: 'Documentos',
          to: { name: 'documentos' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-documento' },
          active: true,
        },
      ],
    },
  }],
}]
